<!--
 * @Description: 销售合同
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="xl-contract-col-page">
    <div class="contract-col-page">
      <div class="card-edit-header">
        <div class="card-edit-header-title">{{ $t('销售合同') }}</div>
        <span v-permission="data.type === 2 ? ['006001180'] : ['007001190']">
          <jw-link v-if="data.permission == 1" @click="updateContract"> {{ $t('新增') }} </jw-link>
        </span>
      </div>
      <jw-space direction="vertical" fill>
        <jw-table sticky-header :loading="loading" :data="data.contractList" :pagination="data.pagination" :columns="data.columns" @pageChange="pageChange">
          <!-- 烽火合同编号插槽--详情 -->
          <template #code="{ record }">
            <jw-link @click="toDetails(record, 'code')" v-if="record.code">{{ record.code }}</jw-link>
            <template v-else>-</template>
          </template>
          <!-- 客户名称插槽--详情 -->
          <template #customerId="{ record }">
            <jw-link @click="toDetails(record, 'customerId')" v-if="record.customerId?.value">{{ record.customerId?.label }}</jw-link>
            <template v-else>-</template>
          </template>
          <!-- 商机名称插槽--详情 -->
          <template #opportunityId="{ record }">
            <jw-link @click="toDetails(record, 'opportunityId')" v-if="record.opportunityId?.value">{{ record.opportunityId?.label }}</jw-link>
            <template v-else>-</template>
          </template>
          <!--报价单名称插槽--详情 -->
          <template #priceSheetId="{ record }">
            <jw-link @click="toDetails(record, 'priceSheetId')" v-if="record?.priceSheetId?.value">{{ record.priceSheetId?.label }}</jw-link>
            <template v-else>-</template>
          </template>
          <!--生命状态 -->
          <template #status="{ record }">
            <xl-status :status="record.statusVal" :statusOrigin="record.statusOrigin"></xl-status>
          </template>
          <!-- 账期  -->
          <template #billPeriod="{ record }">
            <span v-if="record?.billPeriod || record?.billPeriod == 0">{{ record?.billPeriod + '天' }}</span>
            <template v-else>-</template>
          </template>
          <!-- 飞书合同编号-->
          <template #fs_contract_code="{ record }">
            <jw-link @click="openFSDetails(record)" v-if="record?.fieldList?.filter((v) => v.fieldKey === 'fs_contract_code')[0]?.fieldValue">{{ record?.fieldList?.filter((v) => v.fieldKey === 'fs_contract_code')[0]?.fieldValue }}</jw-link>
            <template v-else>-</template>
          </template>
          <!-- 合同金额 -->
          <template #amount="{ record }">
            {{ tools.getPrice(record?.amount).toFixed(2) || '-' }}
          </template>
          <!-- 负责人插槽 -->
          <template #chargePerson="{ record }">
            <xl-avatar v-if="record.chargePerson" :avatar="{ name: record?.chargePersonShowVo?.userName || '', url: record?.chargePersonShowVo?.avatar, id: record?.chargePersonShowVo?.userId }" :size="22" />
            <template v-else>-</template>
          </template>
          <!-- 创建人插槽 -->
          <template #createUser="{ record }">
            <xl-avatar v-if="record?.createUser" :avatar="{ name: record?.createUserShowVo?.userName || '', url: record?.createUserShowVo?.avatar, id: record?.createUserShowVo?.userId }" :size="22" />
            <template v-else>-</template>
          </template>
          <!-- 最后更新人插槽 -->
          <template #updateUser="{ record }">
            <xl-avatar v-if="record.updateUser" :avatar="{ name: record.updateUserShowVo?.userName || '', url: record.updateUserShowVo?.avatar, id: record.updateUserShowVo?.userId }" :size="22" />
            <template v-else>-</template>
          </template>
          <!-- 链接 -->
          <template #urlInfo="{ record }">
            <jw-link v-if="record?.urlInfo" :href="record?.urlInfo" target="_blank">{{ $t('查看') }}</jw-link>
            <template v-else>-</template>
          </template>
          <!-- 操作插槽 -->
        </jw-table>
      </jw-space>
    </div>
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef"></ly-detail>
  </div>
</template>
<script setup>
import { provide, computed, reactive, inject, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { opportunityService } from '@/api/';
import { Message } from '@arco-design/web-vue';
const router = useRouter();
import { tools } from '@/utils/tools';
import useFields from '@/hooks/fields';
import useLoading from '@/hooks/loading';
import { useContractStore, useUserStore, useOrderStore, usePricesheetStore } from '@/store';
import { huaYingOrdId } from '@/utils/const';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const data = reactive({
  record: inject('detailParams')?.record,
  permission: inject('detailParams')?.permission, //协作人权限
  type: inject('detailParams')?.type,
  contract: 8,
  id: null, //商机或者客户id
  opportunityId: null,
  priceId: null,
  columns: [],
  contractList: [],
  page: 1,
  pagination: {
    size: 1,
    current: 1,
    pageSize: 10,
    total: 0,
    showPageSize: false, // 是否显示数据条数选择器
    showTotal: true // 是否显示数据总数
  },
  fieldKey: '',
  customPermission: true //客户是否有协作权限
});

const detailRef = ref(); //公共抽离组件
const { userInfo } = useUserStore(); //用户信息
// 表格表头数据字段
const { enableList, getFields, getFieldLabel } = useFields();
const { loading, setLoading } = useLoading(true);
const getContract = useContractStore(); //合同store
const getOrder = useOrderStore(); //订单store
const getPricesheetStore = usePricesheetStore(); //报价单store
// 判断商机关联的客户是否有权限(负责人或协作人)
const getCustomPermission = async (customerId, type) => {
  try {
    const params = {
      entity: type,
      id: customerId
    };
    const json = await opportunityService.getCustomPermission(params);
    console.log(237, json);
    if (!json.error) {
      data.customPermission = json.result;
    } else {
      Message.error(json.error?.msg || t('获取客户协作权限失败'));
    }
  } catch (e) {
    console.log(e);
    Message.error(e.message || e.statusText || t('获取客户协作权限失败'));
  }
};

const updateContract = async () => {
  const customerId = data.type == 2 ? data.record.find((v) => v.fieldKey === 'id')?.fieldValue : data.record.find((v) => v.fieldKey === 'customerId')?.fieldValue?.value;
  const opportunityId = data.record.find((v) => data.type === 3 && v.fieldKey === 'id')?.fieldValue;
  const qccId = data.record.find((v) => v.fieldKey === 'qccId')?.fieldValue;
  console.log(253, customerId, opportunityId);
  if (data.type === 2 && !qccId && userInfo?.orgId != huaYingOrdId) {
    //客户未关联工商信息
    Message.warning(t('tips.addContractErr'));
    return;
  } else if (data.type === 3) {
    // 商机传递关联的客户ID和客户的entity
    await getCustomPermission(customerId, 2);
    if (!customerId) {
      //商机未关联客户
      Message.warning(t('tips.addContractError'));
      return;
    } else if (!data.customPermission) {
      // 商机关联了客户，但是没有客户操作权限
      Message.warning(t('tips.noPrimisson'));
      return;
    }
  }
  router.push({
    name: 'update-contract',
    params: { id: -1 },
    query: { sign: 1, entity: data.type, customerId, opportunityId }
  });
  provide('globalParams', {
    id: computed(() => data.id)
  });
};
// 去详情页面
const toDetails = (record, type) => {
  console.log(160, record);
  if (type === 'priceSheetId') {
    //报价单
    data.id = record.priceSheetId?.value;
  } else if (type === 'customerId') {
    //客户
    data.id = record.customerId?.value;
  } else if (type === 'opportunityId') {
    //商机
    data.id = record.opportunityId?.value;
  } else if (type === 'code') {
    //合同
    data.id = record.id;
  }
  detailRef.value.openDialog();
};
// 获取所有字段值,生成表格头部
const getField = async (id) => {
  data.id = id;
  getContract.updateRefresh(true);
  getOrder.updateRefresh(false);
  getPricesheetStore.updateRefresh(false);
  await getFields({ id: 8 });
  data.fieldList = enableList;
  data.columns = getColumns();
  data.fieldKey = 'customerId';
  if (data.type == 3) {
    data.fieldKey = 'opportunityId';
  }
  loadTList();
};
// 根据ID获取合同列表
const loadTList = async () => {
  const filterParams = { page: data.page, pageSize: data.pagination.pageSize, conditions: [{ fieldKey: data.fieldKey, fieldType: 12, fieldValue: data.id, type: 1 }] };
  data.contractList = [];
  setLoading(true);
  await getContract
    .getContractLists(filterParams)
    .then((res) => {
      console.log(res);
    })
    .finally(() => {
      setLoading(false);
    });
};
//分页
const pageChange = (current) => {
  data.page = current;
  data.pagination.current = current;
  loadTList();
};
watch(
  () => getContract.contractList,
  (v) => {
    data.contractList = v?.records;
    data.pagination.total = v?.total;
  },
  {
    deep: true
  }
);
provide('globalParams', {
  id: computed(() => data.id),
  type: computed(() => data.type)
});
// 从所有字段中获取表格头部标题
const getColumns = () => {
  const list = [];
  const fieldList = data.fieldList?.filter((i) => (data.type == 2 && i.fieldKey !== 'customerId') || (data.type == 3 && i.fieldKey !== 'opportunityId'));
  fieldList?.forEach((item) => {
    const k = item.fieldKey; //字段标识
    const render = ({ record }) => {
      record = JSON.parse(JSON.stringify(record));
      record.fieldList?.map((keys) => {
        record[keys.fieldKey] = keys.fieldValue;
      });
      const fieldKey = record[k];
      if (fieldKey || fieldKey === 0) {
        if (item.fieldType === 9) {
          if (fieldKey && fieldKey !== '{}') {
            return Object.values(JSON.parse(fieldKey))?.join('/');
          } else {
            return '-';
          }
        } else if (item.fieldType === 6) {
          if (fieldKey instanceof Array) {
            // console.log('查看人员头像303', fieldKey);
            return fieldKey?.map((v) => v.name)?.join(',');
          } else {
            return '-';
          }
        } else if ([2, 3, 4, 5, 10].indexOf(item.fieldType) > -1) {
          // console.log(366, item?.fieldExtObj, fieldKey, item?.fieldExtObj[fieldKey]?.label);
          return getFieldLabel(fieldKey, item.fieldExt, item.fieldType);
        } else {
          if (item.fieldKey == 'billPeriod') {
            return fieldKey + '天';
          } else {
            return fieldKey;
          }
        }
      } else {
        return '-';
      }
    };

    const colType = {
      title: item.fieldName,
      dataIndex: k,
      ellipsis: true,
      tooltip: true
    };
    if (item.type === 1) {
      colType.colType = t('基础字段');
    }
    if (item.type === 2) {
      colType.dataIndex = `${k}Custom`;
    }
    let width = item.fieldName.length <= 5 ? 120 : item.fieldName.length * 30;
    if (k === 'code') {
      //烽火合同编号
      list.push({ ...colType, fixed: 'left', slotName: 'code', width: 250 });
    } else if (k === 'customerId' || k === 'opportunityId' || k === 'priceSheetId' || k === 'fs_contract_code') {
      list.push({ ...colType, slotName: k, width: 250 });
    } else if (k === 'urlInfo') {
      list.push({ ...colType, slotName: k, width: 100 });
    } else if (k === 'chargePerson' || k === 'createUser' || k === 'updateUser' || k === 'status') {
      //负责人.创建人，更新人
      list.push({ ...colType, slotName: k, width: 130 });
    } else if (k === 'amount' || k === 'billPeriod') {
      //合同金额
      list.push({ ...colType, slotName: k, width: 150 });
    } else {
      if (k === 'priceDate' || k === 'businessArea') {
        width = 130;
      }
      if (k === 'currencyType') {
        width = 100;
      }
      if (k === 'gmtUpdated' || k === 'gmtCreated' || k === 'contractPeriod' || k === 'counterparty') {
        width = 200;
      }
      list.push({ ...colType, width, render });
    }
  });
  // list.push({ title: '操作', dataIndex: 'operation', fixed: 'right', slotName: 'operation', colType: false, width: 100 });
  console.log(list);
  return list;
};
defineExpose({ getField });
</script>
<style scoped lang="less">
@import './xl-contract.less';
</style>
